module.exports = __webpack_public_path__ + "static/media/dermaidLogo.8e10e0dd.png";